import {useCallback, useState} from 'react'

export default function useLocalStorageValue(
  key: string,
): [string | null, (value: string) => void] {
  const [value, setValue] = useState(localStorage.getItem(key))

  const setValueAndSaveToStorage = useCallback(
    (newValue: string) => {
      setValue(newValue)
      localStorage.setItem(key, newValue)
    },
    [key],
  )

  return [value, setValueAndSaveToStorage]
}
